import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import CarrotLeft from './icons/actions/carrot-left.js';
import PropTypes from 'prop-types';
const ChevronWrapper = styled.div.withConfig({ displayName: "brc-ChevronWrapper", componentId: "brc-16wl7c" }) `
  pointer-events: none;
`;
ChevronWrapper.displayName = 'ChevronWrapper';
/**
 *
 * @param {*} props You can not access props directly. | optional | {}
 * @property {string} className
 * @property {boolean} disabled
 * @property {boolean} isInvalid
 * @property {boolean} $isOpen
 * @returns React.ReactElement
 */
export const Chevron = ({ className, disabled, isInvalid, $isOpen }) => (_jsx(ChevronWrapper, Object.assign({ className: className, disabled: disabled, isInvalid: isInvalid }, { children: _jsx(CarrotLeft, { style: {
            color: ({ isInvalid, disabled, theme }) => isInvalid ? theme.error : disabled ? theme.scuttleGray500 : theme.azure,
            transform: `rotate(${$isOpen ? '0turn' : '-0.25turn'})`,
            transition: 'transform 0.2s ease-in-out',
            transitionDelay: '0.1s',
            willChange: 'transform',
        } }) })));
Chevron.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    /** Shares the isOpen state with styled-components, but does not pass down to the child as a prop */
    $isOpen: PropTypes.bool,
};
Chevron.defaultProps = {
    disabled: false,
    isInvalid: false,
    $isOpen: false,
};
Chevron.displayName = 'Chevron';
export default styled(Chevron).withConfig({ componentId: "brc-e7mvyw" }) ``;
//# sourceMappingURL=chevron.js.map